import { create } from 'zustand';
import { ConversationFile } from '../../../core/models/fileUpload/conversationFile';

type StageType = {
  isProcessComplete: number; //indicates overall process completion (irrespective of error or success)
  backendInit: number; //stage 1/3
  chunk: number; //stage 2/3
  isTranslated: number; //stage 3/3
};

type DocumentTranslationInfo = {
  translationProgress: number;
  stage: StageType;
  showProgress: boolean;
  fileDetails: { fileBlob: Blob | null; fileName: string };
  tooltipMessage: string;
  fileToTranslate: ConversationFile[] | undefined;
  setShowProgress: (value: boolean) => void;
  setTranslationProgress: (
    stage: string,
    stageStatus: number,
    progress: number,
    tooltipMessage: string
  ) => void;
  resetProgress: () => void;
  setFileDetails: (fileBlob: Blob, fileName: string) => void;
  setFileToTranslate: (files: ConversationFile[] | undefined) => void;
};

const useDocumentTranslationStore = create<DocumentTranslationInfo>((set) => ({
  translationProgress: 0,
  stage: {
    isProcessComplete: 0,
    backendInit: 0,
    chunk: 0,
    isTranslated: 0,
  },
  showProgress: false,
  fileDetails: { fileBlob: null, fileName: '' },
  tooltipMessage: 'File ready for translation',
  fileToTranslate: undefined,
  setShowProgress: (value) =>
    set((state) => ({ ...state, showProgress: value })),
  setTranslationProgress: (stage, stageStatus, progress, tooltipMessage) =>
    set((state) => ({
      ...state,
      stage: { ...state.stage, [stage]: stageStatus },
      translationProgress: progress ? progress : state.translationProgress,
      tooltipMessage: tooltipMessage ? tooltipMessage : state.tooltipMessage,
    })),
  setFileDetails: (fileBlob: Blob | null, fileName: string) =>
    set((state) => ({ ...state, fileDetails: { fileBlob, fileName } })),
  resetProgress: () =>
    set(() => ({
      translationProgress: 0,
      stage: {
        isProcessComplete: 0,
        backendInit: 0,
        chunk: 0,
        isTranslated: 0,
      },
      showProgress: false,
      fileDetails: { fileBlob: null, fileName: '' },
      tooltipMessage: 'File ready for translation',
      fileToTranslate: undefined,
    })),
  setFileToTranslate: (files: ConversationFile[] | undefined) =>
    set((state) => ({ ...state, fileToTranslate: files })),
}));

export default useDocumentTranslationStore;
